module.exports = __webpack_public_path__ + "media/images/pic/brodno/team-hero-9e7751354ed4c59c7ff5a25c1ad38cb4.jpg";